import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ProcessService } from '../../../../../service/process.service'
import { NotifierService } from 'angular-notifier';
import { GlobalSettings } from "../../../../../model/settings.model";
import { ComponentBase } from 'src/app/main/dynamic/component-base';

@Component({
  selector: 'app-file',
  templateUrl: './file.component.html',
  styleUrls: ['./file.component.scss']
})
export class FileComponent extends ComponentBase implements OnInit {

  pathFile: string = this.settings.processosUrl;

  constructor(private processService: ProcessService, private notifier: NotifierService, private settings: GlobalSettings) { super() }

  @Output() delete = new EventEmitter();

  ngOnInit() {
  }

  ngDelete(key: string) {

    this.delete.emit({ id: key });
    console.log(key);
    // console.log(key);
    // // this.attribute = new AttributeModel;
    // //delete this.attribute;
    // this.processService.deleteFile('Files', key).subscribe(() => {
    //   console.log('delete');
    // });
  }

  getPath(key: string) {
    return this.pathFile + '/process/Files/' + key
  }

  onblur() { this.save(); }

  save() {
    console.log(this.attribute);
    this.processService.saveAttribute(this.attribute)
      .subscribe(() => {
        this.showNotification('default', 'Salvo');
      })
  }

  public showNotification(type: string, message: string): void {
    this.notifier.notify(type, message);
  }

}
